import * as Yup from 'yup'

export const uploadBannerSchema = ({ }) => Yup.object().shape({
  // adminId: Yup.string().required('Owner Id Required'),
  // tenantId: Yup.string().required('Tenant ID Required'),
  bannerType: Yup.string().required('Banner Type Required'),
  thumbnail:Yup.mixed().required('Banner Required'),
  name:Yup.string().required('Name Required')
})

const imageWidthAndHeight = (provideFile) => {
  // take the given file (which should be an image) and return the width and height
  const imgDimensions = { width: null, height: null }

  return new Promise(resolve => {
    const reader = new FileReader()

    reader.readAsDataURL(provideFile)
    reader.onload = function () {
      const img = new Image()
      img.src = reader.result

      img.onload = function () {
        imgDimensions.width = img.width
        imgDimensions.height = img.height

        resolve(imgDimensions)
      }
    }
  })
}

const imageDimensionCheck = Yup.addMethod(Yup.mixed, 'imageDimensionCheck', function (message, minRequiredWidth, minRequiredHeight, maxRequiredWidth, maxRequiredHeight) {
  return this.test('image-width-height-check', message, async function (value) {
    const { path, createError } = this

    if (!value) {
      return
    }

    const imgDimensions = await imageWidthAndHeight(value)

    if (imgDimensions.width < minRequiredWidth || imgDimensions.width > maxRequiredWidth) {
      return createError({
        path,
        message: `The image width needs to be betweeen ${minRequiredWidth}px - ${maxRequiredWidth}px!`
      })
    }

    if (imgDimensions.height < minRequiredHeight || imgDimensions.height > maxRequiredHeight) {
      return createError({
        path,
        message: `The image height needs to be between ${minRequiredHeight}px - ${maxRequiredHeight}px!`
      })
    }

    return true
  })
})

export const reasonSchema = () =>
  Yup.object().shape({
    reason: Yup.string()
      .max(100, 'Max 100 characters')
      .required('Reason Required'),
      status: Yup.string()
      .required('Status Required')
  })
